define('superAdminMbAnaResGrsTabs',[
  'module',
  'underscore'
], function(
  module,
  _
) {
  'use strict';

  module.exports = [
    {
      name: 'detail',
      title: _.i18n('mbanaresgrs.details.tabTitle')
    }, {
      name: 'mbanares',
      title: _.i18n('mbanaresgrs.mbanares.tabTitle'),
      isDefault: true
    }
  ];
});
